import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Funnel — reads as "filter incoming items into a narrower set".
 *  Used for moderation-mode select labels and any other "narrow this
 *  list" surface. The neck terminates in a small drop so the shape
 *  doesn't look like a downward triangle. */
export function IcnFilter(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="filter">
      <path d="M2.5 3.25h11l-4 5v4l-3 1v-5l-4-5z" />
    </Svg>
  );
}
